import { render, staticRenderFns } from "./common-top.vue?vue&type=template&id=45afb252&scoped=true&"
import script from "./common-top.vue?vue&type=script&lang=js&"
export * from "./common-top.vue?vue&type=script&lang=js&"
import style0 from "./common-top.vue?vue&type=style&index=0&lang=less&"
import style1 from "./common-top.vue?vue&type=style&index=1&id=45afb252&scoped=scoped&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45afb252",
  null
  
)

export default component.exports